import {Swiper, SwiperSlide} from "swiper/react";
import "./Comics.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-fade";
import {EffectFade, Navigation} from "swiper/modules";
import React, {useMemo, useRef, useState} from "react";
import Helper from "../../../../services/Helper";
import ComicsExitButton from "./ComicsExitButton";
import ComicSlideImage from "./ComicSlideImage";

function ComicsStoryComponent({comicsSetting, cpuStory, closeComics}: any) {
    const basePath = Helper.getRealComicsPath(comicsSetting.path);

    const hasBackground = Boolean(
        comicsSetting?.backgroundPath && comicsSetting?.backgroundSize
    );


    const sliderWrapStyle = useMemo<React.CSSProperties | undefined>(() => {
        if (!hasBackground) {
            return undefined;
        }

        return {
            maxWidth: `${comicsSetting.backgroundSize.x}px`,
            maxHeight: `${comicsSetting.backgroundSize.y}px`,
            position: "relative",
            overflow: "hidden",
        };
    }, [hasBackground, comicsSetting?.backgroundSize]);

    const handleSlideClick = () => {
        if (!swiperRef.current) return;

        swiperRef.current.slideNext();
    };

    const listItems: React.ReactNode[] = [];

    for (let i = 1; i <= comicsSetting.slideNumber; i++) {
        listItems.push(
            <SwiperSlide key={i} onClick={handleSlideClick}>
                <ComicSlideImage
                    index={i}
                    basePath={basePath}
                    hasBackground={hasBackground}
                />
            </SwiperSlide>
        );
    }

    const lockMs = 3000;

    const animatedSlides = comicsSetting?.animatedSlides ?? null;
    const isAnimated = useMemo(
        () => new Set<number>(animatedSlides ?? []),
        [animatedSlides]
    );

    const swiperRef = useRef<any>(null);
    const [locked, setLocked] = useState(false);
    const lockTimer = useRef<number | null>(null);

    const lockNav = (swiper: any) => {
        if (locked) return;

        setLocked(true);
        swiper.allowSlideNext = false;
        swiper.allowSlidePrev = false;
        swiper.allowTouchMove = false;

        lockTimer.current = window.setTimeout(() => {
            swiper.allowSlideNext = true;
            swiper.allowSlidePrev = true;
            swiper.allowTouchMove = true;
            setLocked(false);

            if (lockTimer.current) {
                window.clearTimeout(lockTimer.current);
                lockTimer.current = null;
            }
        }, lockMs);
    };
  const realBgPath = Helper.getRealComicsPath(comicsSetting.backgroundPath);
    return (
        <div className={"comicsSlide"}>
            <div
                className={hasBackground ? "slider-wrap slider-wrap--withBg" : "slider-wrap"}
                style={sliderWrapStyle}
            >
                {hasBackground && (
                    <img
                        src={realBgPath}
                        alt="Comics background"
                        className="comics-background"
                    />
                )}

                <Swiper
                    modules={[Navigation, EffectFade]}
                    spaceBetween={10}
                    slidesPerView={1}
                    loop={false}
                    effect={"fade"}
                    fadeEffect={{
                        crossFade: true
                    }}
                    navigation={{
                        prevEl: ".swiper-Story-prev",
                        nextEl: ".swiper-Story-next",
                    }}
                    onBeforeInit={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    onSlideChange={(swiper) => {
                        const oneBased = (swiper.realIndex ?? swiper.activeIndex) + 1;
                        if (isAnimated.has(oneBased)) {
                            lockNav(swiper);
                        }
                    }}
                >
                    {listItems}
                </Swiper>
            </div>

            <div className="swiper-Story-prev"></div>
            <div className="swiper-Story-next defaultButtonAnimation_9"></div>
            <ComicsExitButton cpuStory={cpuStory} closeComics={closeComics}/>
        </div>
    );
}

export default ComicsStoryComponent;